import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import phoneIcon from 'assets/images/login-call.svg'
import passIcon from 'assets/images/login-lock.svg'
import hidePassIcon from 'assets/images/login-hidepass.svg'
import showPassIcon from 'assets/images/login-showpass.svg'
import BaseModal from './BaseModal'
import { useEffect, useRef, useState } from 'react'
import { getUserQuery, useLogin } from 'dataLayer/user'
import Spinner from 'react-bootstrap/Spinner'
import { useQuery } from 'react-query'
import { API_PATHS } from 'config/routes'
import axios from 'axios'
import i18n from 'i18n'
import { Link } from 'react-router-dom'

function LoginModal({ show, onHide, onShowLoginSMS, ...otherProps }) {
	const { t } = useTranslation()
	const [isPass, setIsPass] = useState(true)
	function handleHidePass() {
		setIsPass(prev => !prev)
	}
	const ref = useRef()
	const errorRef = useRef(null)
	const { mutate, data, isLoading } = useLogin(
		data => {
			axios.get(API_PATHS.getUser).then(res => {
				const laguageUser = res?.data.data?.language
				if (laguageUser) {
					i18n.changeLanguage(laguageUser)
				} else {
					i18n.changeLanguage('la')
				}
			})
			onHide()
		},
		() => {
			if (errorRef.current) {
				errorRef.current.innerText = data?.message
			}
		},
	)
	useEffect(() => {
		if (errorRef.current) {
			errorRef.current.innerText = ''
		}
	}, [show])
	useEffect(() => {
		ref.current.focus()
	}, [])
	const [infoData, setInfoData] = useState({
		msisdn: '',
		password: '',
		grant_type: 'login',
	})
	function handleInfoChange(e) {
		const newInfoData = { ...infoData }
		newInfoData[e.target.id] = e.target.value
		setInfoData(newInfoData)
	}

	function handleLogin(event) {
		if (event.keyCode === 13) {
			mutate(infoData)
		}
	}
	function handleLoginClick(event) {
		mutate(infoData)
	}
	// TODO: validation with zod
	return (
		<>
			<BaseModal show={show} onHide={onHide} {...otherProps}>
				<Container
					onKeyDown={handleLogin}
					className="baseinput-container"
					fluid
				>
					<Modal.Header>
						<Modal.Title id="contained-modal-title-vcenter">
							{t('modal.login.title')}
						</Modal.Title>
						<Modal.Body>
							<p>{t('modal.login.desc')}</p>
						</Modal.Body>
					</Modal.Header>
					<Modal.Body>
						<Form>
							<Form.Group className="mb-3 base-input">
								<img src={phoneIcon} alt="Type your phone number" />
								<Form.Control
									type="phone"
									onChange={handleInfoChange}
									id="msisdn"
									placeholder={t('modal.form.phone')}
									ref={ref}
								/>
							</Form.Group>
							<Form.Group className="mb-3 base-input">
								<img src={passIcon} alt="Type your password" />
								<Button
									variant="dark"
									onClick={handleHidePass}
									style={{
										position: 'absolute',
										top: '50%',
										right: 0,
										translate: '0 -50%',
										marginRight: 20,
										backgroundColor: 'transparent',
										border: 'none',
									}}
								>
									<img
										src={isPass ? hidePassIcon : showPassIcon}
										alt="Show password"
										style={{ margin: 0 }}
									/>
								</Button>
								<Form.Control
									type={isPass ? 'password' : 'text'}
									onChange={handleInfoChange}
									id="password"
									placeholder={t('modal.form.pass')}
								/>
							</Form.Group>
							<Row className="mb-3">
								<Col xs={6}>
									<Form.Group>
										<Form.Check
											type="checkbox"
											label={t('modal.login.save_pass')}
										/>
									</Form.Group>
								</Col>
								{parseInt(data?.responseCode) === 403 ? (
									<Col xs={6} className="error-login text-end">
										<p ref={errorRef}>{data?.message}</p>
									</Col>
								) : null}
							</Row>
						</Form>
					</Modal.Body>
					<Modal.Footer>
						<Button
							variant="primary"
							type="submit"
							disabled={isLoading}
							onClick={handleLoginClick}
						>
							{t('modal.login.login_pass_btn')}
							{isLoading ? (
								<Spinner animation="border" role="status"></Spinner>
							) : null}
						</Button>
						<Button variant="dark" onClick={onShowLoginSMS}>
							{t('modal.login.login_otp')}
						</Button>
						<Button variant="dark">
							<Link
								style={{ color: 'white' }}
								to="https://uid.com.la/auth/signin?redirectUri=http://laogame.arabicatech.vn/&clientId=f7dcb016-00bc-4904-9cb0-1600bcd90437&isFromWeb=true"
							>
								{t('modal.login.login_UniID')}
							</Link>
						</Button>
					</Modal.Footer>
				</Container>
			</BaseModal>
		</>
	)
}

export default LoginModal
